angular.module('app.userProfile.userProfileService', [])
  .factory('app.userProfile.userProfileService', [
    '$http',
    function ($http) {
      "use strict";
          
      let profile = {
        retrieve: function (username) {
          if (username) {
            return $http.get(window.location.api('users/' + username + '/profile'));
          } else {
            return false;
          }
        },
        getFollow: () => {
          return $http.get(window.location.api('user_profiles/follow_all'))
            .then((response) => {
              return response.data && response.data.feed;
            });
        },
        toggleFollow: function (iuserid) {
          return $http.put(window.location.api('users/' + iuserid + '/follow'))
            .then(function (response) {
              let data = response.data;

              if (typeof data.following !== 'undefined') {
                profile.current_user_following = data.following;
              }
              return data;
            });
        }
      };
      return profile;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/userProfile/userProfileService.js